import React from 'react'
import { formatNames } from '../../../utils/formatNames';

export default function ProfileHistoryList({ profileHistory, setProfileHistory }) {
    return (
        <div>
            {/* history data */}
            {
                profileHistory?.length > 0 && (
                    <div className="fixed inset-0 z-50 bg-black/30 flex items-center justify-center top-0 ">
                        <div className="bg-white p-6 rounded-lg w-full space-y-2 max-w-7xl m-2  overflow-y-auto">
                            <h3 className="text-xl text-center  font-semibold text-primary-400">Profile History</h3>
                            <div className="w-full bg-white rounded-xl shadow-md p-5 md:p-8 border border-gray-100">
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div className="space-y-3">
                                        <p className="text-gray-600 text-sm">
                                            <span className="font-medium text-gray-500">Job Title :</span>
                                            <span className="ml-2 text-gray-900 font-semibold text-base">
                                                {formatNames(profileHistory[0]?.job?.title)}
                                            </span>
                                        </p>
                                        <p className="text-gray-600 text-sm">
                                            <span className="font-medium text-gray-500">Candidate Name :</span>
                                            <span className="ml-2 text-gray-900 font-semibold text-base">
                                                {formatNames(profileHistory[0]?.candidate?.name)}
                                            </span>
                                        </p>
                                    </div>

                                    {/* Candidate Details */}
                                    <div className="space-y-3">
                                        <p className="text-gray-600 text-sm">
                                            <span className="font-medium text-gray-500">Candidate Email :</span>
                                            <span className="ml-2 text-gray-900 font-medium text-base">
                                                {formatNames(profileHistory[0]?.candidate?.email)}
                                            </span>
                                        </p>

                                        <p className="text-gray-600 text-sm">
                                            <span className="font-medium text-gray-500">Candidate Contact :</span>
                                            <span className="ml-2  text-gray-900 font-medium text-base">
                                                +{profileHistory[0]?.candidate?.contact?.countryCode}{" "}
                                                {profileHistory[0]?.candidate?.contact?.number}
                                            </span>
                                        </p>
                                    </div>
                                    {/* Job Details */}
                                </div>
                            </div>

                            {
                                profileHistory && (
                                    <div className="md:flex md:justify-center max-h-56">
                                        <div className="overflow-x-auto bg-white rounded-xl   shadow-md  md:w-[1190px]">
                                            <table className="w-full  text-left border-collapse">
                                                <thead className="bg-primary-400 text-white sticky top-0">
                                                    <tr>
                                                        <th className="p-3 text-sm ">Created At</th>
                                                        <th className="p-3 text-sm ">Type</th>
                                                        <th className="p-3 text-sm ">Status</th>
                                                        <th className="p-3 text-sm ">Note</th>
                                                        <th className="p-3 text-sm ">Sub-catogory</th>
                                                        <th className="p-3 text-sm ">Scheduled date</th>
                                                        <th className="p-3 text-sm ">Date of Join</th>
                                                        <th className="p-3 text-sm ">Offered CTC</th>
                                                        <th className="p-3 text-sm ">Employement ID</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {profileHistory?.length > 0 ? (
                                                        profileHistory.map((pro) => {
                                                            const allActions = (pro.actionHistory || []).slice().reverse(); // ✅ reverse copy
                                                            const allStatuses = (pro.statusHistory || []).slice().reverse(); // ✅ reverse copy
                                                            console.log("allStatuses", allStatuses)
                                                            // If no action history, skip rendering
                                                            if (allActions.length === 0) return null;

                                                            return (
                                                                <React.Fragment key={pro._id}>
                                                                    {allActions.map((action, i) => {
                                                                        console.log("Action Index", i)
                                                                        if (action.type === "pipeline") {
                                                                            return (
                                                                                <tr
                                                                                    key={`${pro._id}-pipeline-${i}`}
                                                                                    className="border-b border-slate-100 hover:bg-blue-50 transition"
                                                                                >
                                                                                    {/* TYPE */}
                                                                                    <td className="p-2">
                                                                                        {new Date(action.timestamp).toLocaleDateString("en-GB")}
                                                                                    </td>
                                                                                    <td className="p-2">{formatNames(action.type)}</td>
                                                                                    <td className="p-2">-</td>
                                                                                    <td className="p-2">-</td>
                                                                                    <td className="p-2">-</td>
                                                                                    <td className="p-2">-</td>
                                                                                    <td className="p-2">-</td>
                                                                                    <td className="p-2">-</td>
                                                                                    <td className="p-2">-</td>

                                                                                </tr>
                                                                            );
                                                                        }

                                                                        // If it's a submission, list all statuses
                                                                        if (action.type === "submission" && allStatuses.length > 0) {

                                                                            const status = allActions[0].type === 'pipeline' ? allStatuses[i - 1] : allStatuses[i];
                                                                            console.log("status", allStatuses[i], i)
                                                                            return (
                                                                                <tr
                                                                                    key={`${pro._id}-submission-${i}`}
                                                                                    className="border-b border-slate-100 hover:bg-blue-50 transition"
                                                                                >
                                                                                    <td className="p-2">
                                                                                        {new Date(status?.timestamp).toLocaleDateString("en-GB")}
                                                                                    </td>
                                                                                    <td className="p-2">{formatNames(action.type)}</td>
                                                                                    <td className="p-2">{formatNames(status?.status?.statusLabel)}</td>
                                                                                    <td className="p-2">{status?.note || "-"}</td>
                                                                                    <td className="p-2">{status?.subcategory || "-"}</td>

                                                                                    <td className="p-2">
                                                                                        {status?.scheduledDate
                                                                                            ? new Date(status?.scheduledDate).toLocaleDateString("en-GB")
                                                                                            : "-"}
                                                                                    </td>
                                                                                    <td className="p-2">
                                                                                        {status?.doj
                                                                                            ? new Date(status?.doj).toLocaleDateString("en-GB")
                                                                                            : "-"}
                                                                                    </td>
                                                                                    <td className="p-2">{status?.offeredCtc || "-"}</td>
                                                                                    <td className="p-2">{status?.empId || "-"}</td>

                                                                                </tr>
                                                                            );
                                                                        }

                                                                        return null;
                                                                    })}
                                                                </React.Fragment>
                                                            );
                                                        })
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="8" className="text-center p-4 text-gray-500">
                                                                No profile history available
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                )
                            }

                            <div className='flex justify-end'>
                                <button
                                    onClick={() => setProfileHistory(null)}
                                    className="mt-4 px-4 py-2 bg-primary-400 text-white rounded "
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>)
            }
        </div>
    )
}
